import { render, staticRenderFns } from "./CategoryFiltersList.vue?vue&type=template&id=4f4533a6&scoped=true&name=category-filters-list&"
import script from "./CategoryFiltersList.vue?vue&type=script&lang=js&"
export * from "./CategoryFiltersList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFiltersList.vue?vue&type=style&index=0&id=4f4533a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4533a6",
  null
  
)

/* custom blocks */
import block0 from "./CategoryFiltersList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports